import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import Card from '@avila-tek/ui/src/card/Card';
import { Company } from '../../models';
import img from '../../public/images/meit-purple.png';

interface AllyCardProps {
  ally: Company;
  categoryId: string;
}

function AllyCard({ ally, categoryId }: AllyCardProps) {
  return (
    <Card className="bg-system-100 rounded-lg ease-in-out duration-300 flex flex-col overflow-hidden border pb-2 w-[240px] h-[224px] group">
      <Link
        href={`catalogue/category/${categoryId}?allyQueryParam=${ally._id}`}
      >
        <div className="relative overflow-clip group">
          {ally?.logo ? (
            <img
              src={ally?.logo.src}
              alt="ally_logo"
              className="object-cover w-full h-[180px] object-center cursor-pointer ease-in-out duration-150 scale-110 group-hover:scale-100"
            />
          ) : (
            <Image
              alt="Imagen de perfil"
              src={img}
              className="object-cover w-full h-[180px] object-center cursor-pointer ease-in-out duration-150 scale-110 group-hover:scale-100"
            />
          )}
        </div>
        <section className="h-full w-full p-2 border-t">
          <h3 className="w-full text-neutral-cold-800 font-bold text-base ">
            {ally?.name}
          </h3>
        </section>
      </Link>
    </Card>
  );
}

export default AllyCard;
